(function () {
  'use strict';

  function init() {
    var gallery = document.querySelector('[data-heritage-gallery]');
    var lightbox = document.querySelector('[data-heritage-lightbox]');
    var dataNode = document.querySelector('[data-heritage-gallery-data]');

    if (!gallery || !lightbox || !dataNode) return;

    var media = [];
    try {
      media = JSON.parse(dataNode.textContent);
    } catch (err) {
      console.warn('Heritage gallery: invalid JSON data', err);
      return;
    }

    var stage = lightbox.querySelector('[data-lightbox-stage]');
    var counter = lightbox.querySelector('[data-lightbox-counter]');
    var closeBtn = lightbox.querySelector('[data-lightbox-close]');
    var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-lightbox-next]');

    var current = 0;
    var lastFocus = null;

    function render(index) {
      if (!media[index]) return;
      var item = media[index];
      stage.innerHTML = '';
      var img = document.createElement('img');
      img.src = item.src;
      img.alt = item.alt || '';
      img.draggable = false;
      stage.appendChild(img);
      counter.textContent = (index + 1) + ' / ' + media.length;
      current = index;

      if (media.length <= 1) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
      } else {
        prevBtn.style.display = '';
        nextBtn.style.display = '';
      }
    }

    function open(index) {
      lastFocus = document.activeElement;
      lightbox.hidden = false;
      lightbox.setAttribute('data-open', '');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      render(index || 0);
      closeBtn.focus();
    }

    function close() {
      lightbox.removeAttribute('data-open');
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      stage.innerHTML = '';
      document.body.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    function next() {
      render((current + 1) % media.length);
    }

    function prev() {
      render((current - 1 + media.length) % media.length);
    }

    gallery.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-zoom-trigger]');
      if (!trigger) return;
      e.preventDefault();
      var idx = parseInt(trigger.getAttribute('data-zoom-index'), 10) || 0;
      open(idx);
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', prev);
    nextBtn.addEventListener('click', next);

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target === stage) close();
    });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') next();
      else if (e.key === 'ArrowLeft') prev();
    });

    var touchStartX = 0;
    var touchEndX = 0;
    stage.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchEndX - touchStartX;
      if (Math.abs(diff) < 40) return;
      if (diff < 0) next();
      else prev();
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
